module.exports = __webpack_public_path__ + "img/xinxi.2f4895f0.jpg";